export enum Environment {
  PRODUCTION = 'PRODUCTION',
  STAGING = 'STAGING',
  PREVIEW = 'PREVIEW',
  DEVELOPMENT = 'DEVELOPMENT',
  UNKNOWN = 'UNKNOWN',
}

export const SEGMENT_KEYS = {
  PROD: 'FkWnSreP4BYomWI99baEAIqxbatB9o5A',
  DEV: 'M61mi5zgOowUXOhIBSl5jTt0b1W140Op',
}

export function detectEnvironment() {
  if (process.env.REACT_APP_CLOUDTRUCKS_ENV === 'production') {
    return Environment.PRODUCTION
  }

  if (process.env.REACT_APP_CLOUDTRUCKS_ENV === 'staging') {
    return Environment.STAGING
  }

  if (process.env.REACT_APP_CLOUDTRUCKS_ENV === 'preview') {
    return Environment.PREVIEW
  }

  if (process.env.REACT_APP_CLOUDTRUCKS_ENV === 'development') {
    return Environment.DEVELOPMENT
  }

  return detectEnvironmentFromUrl()
}

export function detectEnvironmentFromUrl() {
  const originUrl = window.location.origin

  switch (originUrl) {
    case 'https://app.cloudtrucks.com':
    case 'https://console.cloudtrucks.com':
      return Environment.PRODUCTION
    case 'https://app.cloudtrucks-staging.com':
    case 'https://console.cloudtrucks-staging.com':
      return Environment.STAGING
    case 'https://localhost:3000':
    case 'https://localhost:3001':
    case 'http://localhost:3000':
    case 'http://localhost:3001':
    case 'http://localhost:8000':
    case 'http://webapp:8000':
      return Environment.DEVELOPMENT
    default:
      return Environment.UNKNOWN
  }
}

export function isProductionEnv() {
  return detectEnvironment() === Environment.PRODUCTION
}

export function isStagingEnv() {
  return detectEnvironment() === Environment.STAGING
}

export function isDevelopmentEnv() {
  return detectEnvironment() === Environment.DEVELOPMENT
}

export function getStaticUrl() {
  if (isProductionEnv()) {
    return 'https://static.cloudtrucks.com/app'
  }
  if (isStagingEnv()) {
    return 'https://static.cloudtrucks-staging.com/app'
  }

  return '' // Use relative path for development
}

export const isProduction = process.env.NODE_ENV === 'production'
export const isDevelopment = process.env.NODE_ENV === 'development'
export const isIntegrationTest = process.env.REACT_APP_INTEGRATION === 'true'

export function isConsole() {
  return (
    window.location.origin.includes('console') ||
    window.location.origin.includes(':3001') ||
    window.location.origin.includes(':3003')
  )
}

export const LOG_ROCKET_APP_ID_WEB = '7zp8gw/cloudtrucks-web'
export const LOG_ROCKET_APP_ID_IOS = '7zp8gw/cloudtrucks-ios'
export const LOG_ROCKET_APP_ID_ANDROID = '7zp8gw/cloudtrucks-android'
export const LOG_ROCKET_APP_ID_CONSOLE = '7zp8gw/cloudtrucks-console'
export const LOG_ROCKET_FUEL_APP_ID_IOS = '7zp8gw/fuelapp-ios'
export const LOG_ROCKET_FUEL_APP_ID_ANDROID = '7zp8gw/fuelapp-android'
export const privateFieldNames = [
  'password_passthrough',
  'password_encrypted',
  'api_key_encrypted',
  'tax_id_encrypted',
  'tax_form_encrypted',
  'ssn_encrypted',
]

export function getAppUrl() {
  switch (detectEnvironment()) {
    case Environment.STAGING:
    case Environment.PREVIEW:
      return 'https://app.cloudtrucks-staging.com'
    case Environment.PRODUCTION:
      return 'https://app.cloudtrucks.com'
    case Environment.DEVELOPMENT:
    default:
      return 'http://localhost:3000'
  }
}

export function getBasisTheoryPublicKey() {
  if (detectEnvironmentFromUrl() === Environment.PRODUCTION) {
    return 'key_prod_us_pub_XcREQe6WCfAk8UcGDgSyDt'
  }

  return 'key_test_us_pub_RXhqSph4xYM4LCKtNdR96A'
}

export function getInternalTeamId() {
  switch (detectEnvironment()) {
    case Environment.STAGING:
      return 'c0fde869-6012-4725-91cf-713bafbaa6cd'
    case Environment.PRODUCTION:
      return 'a31b2c07-922b-4fef-b67c-4c05a00d7872'
    case Environment.DEVELOPMENT:
      return '12dd3935-531a-4117-8fd6-39203cc4b5f8'
    default:
      return 'a31b2c07-922b-4fef-b67c-4c05a00d7872'
  }
}

export function getTrailerUnavailableTeamId() {
  switch (detectEnvironment()) {
    case Environment.STAGING:
      return 'ef066d64-149d-4e18-83be-8183e9564baa'
    case Environment.PRODUCTION:
      return 'a4878948-0a27-43dc-bb9f-8458fc50ca6e'
    case Environment.DEVELOPMENT:
      return 'df40c1e1-dbbb-4c3c-8c69-8233340ae435'
    default:
      return 'a4878948-0a27-43dc-bb9f-8458fc50ca6e'
  }
}
